export interface ExportQueryTypeConfig {
  id: string;
  label: string;
  description: string;
  parameters: ExportParameterConfig[];
}

export interface ExportParameterConfig {
  key: string;
  label: string;
  type: 'number' | 'text' | 'datetime' | 'email';
  placeholder?: string;
  required?: boolean;
  defaultValue?: any;
  validation?: {
    min?: number;
    max?: number;
    pattern?: string;
  };
  gridCols?: number; // For grid layout (1-2)
}

export const EXPORT_QUERY_TYPES: ExportQueryTypeConfig[] = [
  {
    id: "users-active-months",
    label: "Users Active Months",
    description: "Export users based on their activity in specific months",
    parameters: [
      {
        key: "activeStartMonth",
        label: "Active Start Month",
        type: "number",
        placeholder: "6",
        defaultValue: 6,
        validation: { min: 1, max: 12 },
        gridCols: 1
      },
      {
        key: "activeEndMonth",
        label: "Active End Month",
        type: "number",
        placeholder: "7",
        defaultValue: 7,
        validation: { min: 1, max: 12 },
        gridCols: 1
      },
      {
        key: "inactiveStartMonth",
        label: "Inactive Start Month",
        type: "number",
        placeholder: "8",
        defaultValue: 8,
        validation: { min: 1, max: 12 },
        gridCols: 1
      },
      {
        key: "minAge",
        label: "Min Age",
        type: "number",
        placeholder: "16",
        defaultValue: 16,
        validation: { min: 13, max: 25 },
        gridCols: 1
      },
      {
        key: "maxAge",
        label: "Max Age",
        type: "number",
        placeholder: "21",
        defaultValue: 21,
        validation: { min: 13, max: 25 },
        gridCols: 1
      },
      {
        key: "groupId",
        label: "Group ID",
        type: "text",
        placeholder: "731558b9-4f61-47db-a0c9-34ecf4b698a8",
        defaultValue: "731558b9-4f61-47db-a0c9-34ecf4b698a8",
        gridCols: 2
      }
    ]
  },
  {
    id: "users-incomplete-onboarding",
    label: "Users Incomplete Onboarding",
    description: "Export users who haven't completed their onboarding process",
    parameters: [
      {
        key: "onboardingStep",
        label: "Minimum Onboarding Step",
        type: "number",
        placeholder: "2",
        defaultValue: 0,
        validation: { min: 0, max: 10 },
        gridCols: 1
      },
      {
        key: "createdAfter",
        label: "Created After",
        type: "datetime",
        placeholder: "2025-04-19 00:00:00",
        defaultValue: "2025-04-19 00:00:00",
        gridCols: 1
      }
    ]
  }
];

export const getQueryTypeConfig = (id: string): ExportQueryTypeConfig | undefined => {
  return EXPORT_QUERY_TYPES.find(config => config.id === id);
};

export const getDefaultParameters = (queryTypeId: string): Record<string, any> => {
  const config = getQueryTypeConfig(queryTypeId);
  if (!config) return {};
  
  return config.parameters.reduce((acc, param) => {
    if (param.defaultValue !== undefined) {
      acc[param.key] = param.defaultValue;
    }
    return acc;
  }, {} as Record<string, any>);
};
